module.exports = __webpack_public_path__ + "static/img/shellymobile.0aa142d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WhoAreWe/shellymobile.png
// module id = q8oJ
// module chunks = 0